import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bidKeys } from '@tempmee/awards';
import type { ISubmitBidApplicationParams } from '../clients/SubmitBidApplication';
import { submitBidApplicationService } from '../services/SubmitBidApplication';

export const useSubmitBidApplication = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: ISubmitBidApplicationParams) => submitBidApplicationService(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bidKeys.all });
    },
    meta: { skipGlobalErrorToaster: true },
  });
};
